;(function ($) {
	$.fn.sidenavSections = function () {
		return $(this).each(function () {
			var body = $(this);
			var scrolling = false;
			var topPadding = 110;
			var sidenavSections = body.find('[data-sidenav-section]');

			if(sidenavSections.length) {
			    var sidenav = $('<nav/>').addClass('sidenav');

			    var i = 1;
			    sidenavSections.each(function() {
			        var section = $(this);
			        section.attr('id', 'sidenav-section-' + i);
			        var sectionAnchor = $('<a href="#sidenav-section-' + i + '"><span>' + section.data('sidenav-section') + '</span>');

			        sectionAnchor.on('click', function(e) {
			            e.preventDefault();
						$('body,html').animate({'scrollTop':section.offset().top - topPadding}, 500);
                    });

			        sectionAnchor.appendTo(sidenav);

			        i++;
                });

			    sidenav.appendTo(body);
            }

            function updateSections() {
				var halfWindowHeight = $(window).height()/2,
					scrollTop = $(window).scrollTop();
				sidenavSections.each(function(){
					var sidenavSection = $(this),
						sectionId = sidenavSection.attr('id'),
						navigationItem = sidenav.find('[href^="#'+ sectionId +'"]');
					if((sidenavSection.offset().top - halfWindowHeight < scrollTop ) && ( sidenavSection.offset().top + sidenavSection.height() - halfWindowHeight > scrollTop)) {
						navigationItem.addClass('active')
                    } else {
						navigationItem.removeClass('active');
                    }
				});
				scrolling = false;
            }

			function checkScroll() {
				if(!scrolling) {
					scrolling = true;
					(!window.requestAnimationFrame) ? setTimeout(updateSections, 300) : window.requestAnimationFrame(updateSections);
				}
			}

			$(window).on('scroll', checkScroll);
			$(window).on('load', updateSections());

		});
	};
	$(function () {
		$('body').sidenavSections();
	});
})(jQuery);
